if (!customElements.get('product-photos')) {
  class ProductPhotos extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('[data-product-photos-tile]'));
      const modalId = this.dataset.modal;
      this.modal = modalId ? document.querySelector(modalId) : null;
      this.image = this.modal && this.modal.querySelector('[data-product-photos-image]');
      this.media = this.modal && this.modal.querySelector('[data-product-photos-media]');
      this.currentIndex = -1;
      this.modalSizes = '(min-width: 578px) 520px, 90vw';

      if (!this.modal || !this.image || this.tiles.length === 0) return;

      this.onImageLoad = this.onImageLoad.bind(this);
      this.image.addEventListener('load', this.onImageLoad);
      this.image.addEventListener('error', this.onImageLoad);

      // Capture phase so the image swaps before <modal-opener>'s bubble-phase
      // listener calls modal.show().
      this.addEventListener('click', (event) => {
        const tile = event.target.closest('[data-product-photos-tile]');
        if (!tile || !this.contains(tile)) return;
        const idx = parseInt(tile.dataset.index, 10);
        if (Number.isFinite(idx)) this.loadIndex(idx);
      }, true);

      this.modal.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-action]');
        if (!btn) return;
        const action = btn.dataset.action;
        if (action === 'prev') this.go(-1);
        else if (action === 'next') this.go(1);
      });

      this.handleKey = this.handleKey.bind(this);
      document.addEventListener('keydown', this.handleKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleKey);
      if (this.image) {
        this.image.removeEventListener('load', this.onImageLoad);
        this.image.removeEventListener('error', this.onImageLoad);
      }
    }

    setLoading(isLoading) {
      if (!this.media) return;
      this.media.classList.toggle('is-loading', isLoading);
    }

    onImageLoad() {
      this.setLoading(false);
      this.preloadAdjacent();
    }

    loadIndex(idx) {
      if (idx < 0 || idx >= this.tiles.length || !this.image) return;
      const tile = this.tiles[idx];
      const src = tile.dataset.src;
      if (!src) return;
      const srcset = tile.dataset.srcset || '';
      const alt = tile.dataset.alt || '';
      this.currentIndex = idx;

      if (this.dataset.modalAdapt === 'true') {
        const aspect = parseFloat(tile.dataset.aspect);
        if (Number.isFinite(aspect) && aspect > 0) {
          this.style.setProperty('--modal-aspect-ratio', aspect);
        }
      }

      this.setLoading(true);

      this.image.setAttribute('src', src);
      if (srcset) this.image.setAttribute('srcset', srcset);
      else this.image.removeAttribute('srcset');
      this.image.setAttribute('alt', alt);

      // Cached images may already be loaded without firing `load` again.
      if (this.image.complete && this.image.naturalWidth > 0) {
        this.onImageLoad();
      }
    }

    preloadAdjacent() {
      if (this.tiles.length < 2) return;
      const next = (this.currentIndex + 1) % this.tiles.length;
      const prev = (this.currentIndex - 1 + this.tiles.length) % this.tiles.length;
      this.preloadIndex(next);
      if (prev !== next) this.preloadIndex(prev);
    }

    preloadIndex(idx) {
      const tile = this.tiles[idx];
      if (!tile || !tile.dataset.src) return;
      const preloader = new Image();
      if (tile.dataset.srcset) {
        preloader.sizes = this.modalSizes;
        preloader.srcset = tile.dataset.srcset;
      }
      preloader.src = tile.dataset.src;
    }

    go(direction) {
      if (this.tiles.length === 0 || this.currentIndex < 0) return;
      const next = (this.currentIndex + direction + this.tiles.length) % this.tiles.length;
      this.loadIndex(next);
    }

    handleKey(event) {
      if (!this.modal || !this.modal.hasAttribute('open')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.go(-1);
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        this.go(1);
      }
    }
  }
  customElements.define('product-photos', ProductPhotos);
}
